export const GUEST = 'guest';
export const BEARER = 'Bearer';
export const AUTHORIZATION = 'Authorization';
export const X_MERCHANT_ID = 'X-Merchant-Id';
export const X_CHECKOUT_ID = 'X-Checkout-Id';
export const X_CUSTOMER_ID = 'X-Customer-Id';
export const X_UPSTREAM_ENV = 'X-Upstream-Env';
export const HCP_TOKEN_HEADER = 'hcp-token';
export const API_AUTH = 'auth';
export const API_CUSTOMER = 'customer';
export const API_PAYMENT = 'payment';
export const enum PAYMENT_TRANSACTION_TYPE {
  SALE = 'SALE',
}
export enum HTTP_STATUS {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NETWORK_CONNECT_TIMEOUT_ERROR = 599,
}
export enum APP_ENV {
  test = 'test',
  stage = 'stage',
  prod = 'prod',
}
export enum SETTINGS_HOST {
  'test' = 'https://dev-wallet.healthsafepay.com',
  'stage' = 'https://stg-wallet.healthsafepay.com',
  'prod' = 'https://wallet.healthsafepay.com',
}
const DEFAULT_DOCUMENT_TITLE = 'Convenient Checkout Gateway';
export const DOCUMENT_TITLE = {
  WALLET_LANDING_PAGE: `${DEFAULT_DOCUMENT_TITLE} - Your Wallet`,
  GUEST_LANDING_PAGE: `${DEFAULT_DOCUMENT_TITLE} - Payment`,
  ADD_PAYMENT: `${DEFAULT_DOCUMENT_TITLE} - Add Payment`,
  REMOVE_PAYMENT: `${DEFAULT_DOCUMENT_TITLE} - Remove Payment`,
  EDIT_PAYMENT: `${DEFAULT_DOCUMENT_TITLE} - Edit Payment`,
};
export const DEFAULT_PAYMENT_DESCRIPTION = 'UI widget payment';
